(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.phs-section[data-section-id]').forEach(function (section) {
    if (section.dataset.phsInit) return;
    section.dataset.phsInit = 'true';

    const slides = Array.from(section.querySelectorAll('.phs-slide'));
    const dots = Array.from(section.querySelectorAll('.phs-dot'));
    const slideshow = section.querySelector('.phs-slideshow');
    let current = 0;
    let timer = null;

    const autoplay = slideshow && slideshow.dataset.autoplay === 'true';
    const speed = parseInt((slideshow && slideshow.dataset.speed) || '5', 10) * 1000;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = (index + slides.length) % slides.length;
      
      const activeSlide = slides[current];
      section.style.setProperty('--phs-accent-color', activeSlide.style.getPropertyValue('--phs-accent-color'));
      section.style.setProperty('--phs-button-label-color', activeSlide.style.getPropertyValue('--phs-button-label-color'));
      section.style.setProperty('--phs-bg-color', activeSlide.style.getPropertyValue('--phs-bg-color'));

      activeSlide.classList.add('is-active');
      activeSlide.setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    const initialSlide = slides[current];
    if (initialSlide) {
      section.style.setProperty('--phs-accent-color', initialSlide.style.getPropertyValue('--phs-accent-color'));
      section.style.setProperty('--phs-button-label-color', initialSlide.style.getPropertyValue('--phs-button-label-color'));
      section.style.setProperty('--phs-bg-color', initialSlide.style.getPropertyValue('--phs-bg-color'));
    }

    function clearTimer() {
      if (timer) clearInterval(timer);
    }

    section.addEventListener('click', function (e) {
      const prevBtn = e.target.closest('.phs-arrow--prev');
      const nextBtn = e.target.closest('.phs-arrow--next');
      
      if (prevBtn) {
        clearTimer();
        goTo(current - 1);
      } else if (nextBtn) {
        clearTimer();
        goTo(current + 1);
      }
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { clearTimer(); goTo(i); });
    });

    if (autoplay && slides.length > 1) {
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
